import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

// define an enum if feature gate key is used anywhere else in the app
export enum WORKFORCE_HUB_FEATURE_FLAGS {
  WFM_DRIVER_WALKTHROUGH_IMPROVEMENTS_ENABLED = 'wfm-driver-walkthrough-improvements-enabled',
  WFM_DQ_DRIVER_UPLOAD_ENABLED = 'wfm-dq-driver-upload-enabled',
  WFM_TRAINING_PAID_SKU_ENABLED = 'wfm-training-paid-sku-enabled',
  WFM_DRIVER_QUALIFICATION_STATUS_ENABLED = 'wfm-dq-status-phase-1-enabled',
  WFM_TRAINING_ENABLED = 'wfm-training-enabled',
  WFM_EXPIRATION_ALERTS_GRANULAR_DAYS_FILTER_ENABLED = 'wfm-expiration-alerts-granular-days-filter-enabled',
  WFM_DRIVER_DOCUMENT_EXPIRATION_ALERT_EXTERNAL_EMAIL_ENABLED = 'wfm-driver-document-expiration-alert-external-email-enabled'
}

@Injectable({ providedIn: 'root' })
export class WorkforceHubFeatureFlagService {
  constructor(private statsigService: StatsigService) { }

  public isWFMWalkthroughImprovementsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(WORKFORCE_HUB_FEATURE_FLAGS.WFM_DRIVER_WALKTHROUGH_IMPROVEMENTS_ENABLED);
  }

  public isWFMDQDriverUploadEnabled(): boolean {
    return this.statsigService
      .evaluateGate(WORKFORCE_HUB_FEATURE_FLAGS.WFM_DQ_DRIVER_UPLOAD_ENABLED);
  }

  public isTrainingPaidSKUEnabled(): boolean {
    return this.statsigService
      .evaluateGate(WORKFORCE_HUB_FEATURE_FLAGS.WFM_TRAINING_PAID_SKU_ENABLED);
  }

  public isDQStatusEnabled(): boolean {
    return this.statsigService
      .evaluateGate(WORKFORCE_HUB_FEATURE_FLAGS.WFM_DRIVER_QUALIFICATION_STATUS_ENABLED);
  }

  public isWFMTrainingEnabled(): boolean {
    return this.statsigService.evaluateGate(WORKFORCE_HUB_FEATURE_FLAGS.WFM_TRAINING_ENABLED);
  }

  public isWFMExpirationAlertsGranularDaysFilterEnabled(): boolean {
    return this.statsigService
      .evaluateGate(WORKFORCE_HUB_FEATURE_FLAGS.WFM_EXPIRATION_ALERTS_GRANULAR_DAYS_FILTER_ENABLED);
  }

  public isWFMDriverDocumentExpirationAlertExternalEmailEnabled(): boolean {
    return this.statsigService
      .evaluateGate(WORKFORCE_HUB_FEATURE_FLAGS.WFM_DRIVER_DOCUMENT_EXPIRATION_ALERT_EXTERNAL_EMAIL_ENABLED);
  }

}
